import { Icon, Link, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as PuzzleImage } from '../../../../assets/images/integrations/puzzle.svg'
import { getImageClassName } from '../../../../utils/getClassName'
import * as Styled from './styles'

const ADDONS_LINK = 'https://shine.co/dk/integrationer'

export const IntegrationsFooter = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <Styled.IntegrationFooterWrapper>
      <Styled.IntegrationFooterImageWrapper className={getImageClassName()}>
        <PuzzleImage />
      </Styled.IntegrationFooterImageWrapper>
      <div>
        <Text variant="bodySM" colorVariant="primary">
          {t('integrations.footer.subtitle')}
        </Text>
        <Styled.IntegrationFooterLinkWrapper>
          <Text variant="bodyLG" weight="bold">
            <Link href={ADDONS_LINK} target="_blank" withAnimation>
              {t('integrations.footer.title_link')}
            </Link>
            &nbsp;
          </Text>
          <Text variant="bodyLG" weight="bold">
            {t('integrations.footer.title')}
          </Text>
        </Styled.IntegrationFooterLinkWrapper>
      </div>
      <Icon icon="chevronRight" />
    </Styled.IntegrationFooterWrapper>
  )
}
